export const wt_kunder = 1000;
export const wt_kontakter = 1001;
export const wt_vikarer = 1002;
export const wt_tilbud = 1003;
export const wt_kandidater = 1004;
export const wt_oppdrag = 1005;
export const wt_rekruttering = 1006;
export const wt_rekrutteringskandidat = 1007;
export const wt_dagbok = 1008;
export const wt_dokumenter = 1009;
export const wt_global = 1010;
export const wt_firma = 1011;
export const wt_avdelinger = 1012;
export const wt_emailbeskjeder = 1013;
export const wt_ansatte = 1014;
export const wt_faktura = 1015;
export const wt_timelister = 1016;
export const wt_timelistegrunnlag = 1017;
export const wt_telefonnummere = 1018;
export const wt_oppdragskostnader = 1019;
export const wt_superglobal = 1020;
export const wt_passord = 1021;
export const wt_grupper = 1022;
export const wt_gruppemedlemmer = 1023;
export const wt_tilbudsutlegg = 1024;
export const wt_uketidsangivelse = 1025;
export const wt_avtaler = 1026;
export const wt_dokumentbehandling = 1027;
export const wt_systemhendelser = 1028;
export const wt_etimelistelinjer = 1029;
export const wt_vikarforvikaren = 1030;
export const wt_eksportfiler = 1031;
export const wt_produkter = 1032;
export const wt_produktpris = 1033;
export const wt_lagretesok = 1034;
export const wt_tekst = 1035;
export const wt_dtekst = 1036;
export const wt_portaloppdatering = 1037;
export const wt_typer = 1038;
export const wt_aaregister = 1039;
export const wt_systemlogg = 1040;
export const wt_kontoutskrift = 1041;
export const wt_firmakunder = 1042;
export const wt_tilskudd = 1043;
export const wt_tilskuddimportert = 1044;
export const wt_vikarpriser = 1045;
export const wt_eksternadresser = 1046;
export const wt_firmavikarer = 1047;
export const wt_vikarersluttet = 1048;
export const wt_rekrutteringsutlegg = 1049;
export const wt_timelinjer = 1050;
export const wt_kurs = 1051;
export const wt_praksis = 1052;
export const wt_skoler = 1053;
export const wt_kunnskap = 1054;
export const wt_engangspassord = 1055;
export const wt_perioder = 1056;
export const wt_linker = 1057;
export const wt_bilde = 1058;
export const wt_firmakontakter = 1059;
export const wt_mva = 1060;
export const wt_mangedageransatt = 1061;
export const wt_mangedagervikar = 1062;
export const wt_automail = 1066;
export const wt_emailvedlegg = 1068;
export const wt_vikarsok = 1069;
export const wt_kundesok = 1070;
export const wt_postnummer = 1071;
export const wt_omraader = 1072;
export const wt_kommuner = 1073;
export const wt_fylker = 1074;
export const wt_tellere = 1075;
export const wt_feilpassord = 1077;
export const wt_importertfraekstern = 1078;
export const wt_importid = 1079;
export const wt_controlrecsets = 1080;
export const wt_helligdager = 1082;
export const wt_telefonlogg = 1083;
export const wt_sesjoner = 1084;
export const wt_emailinn = 1085;
export const wt_emailut = 1086;
export const wt_aaregisterauto = 1087;
export const wt_bankoppdrag = 1088;
export const wt_sjekkliste = 1089;
export const wt_sjekklistevalg = 1090;
export const wt_adresser = 1091;
export const wt_forlengelser = 1092;
export const wt_vikarerpresentert = 1093;
export const wt_avdelingervikarer = 1094;
export const wt_divtekster = 1095;
export const wt_reiseregning = 1096;
export const wt_localtransl = 1097;
export const wt_samtykker = 1098;

export const wt_arkivimport = 9000000;
export const wt_arkivimport_item = 9000001;
export const wt_rssartikkel = 9000002;
export const wt_nyhetsartikkel = 9000003;
export const wt_changelogartikkel = 9000004;

export const wt_ukjent = -3000;

export const wtw_utleide_medarbeidere = 5100;
export const wtw_prosess_crm = 5101;
export const wtw_faktura_omsetning = 5102;
export const wtw_nyhetsfeed = 5103;
export const wtw_ekstern_nettside = 5104;
export const wtw_systemhendelser = 5105;
export const wtw_meldinger_og_epost = 5106;
export const wtw_dagbok = 5107;
export const wtw_kandidater_og_medarbeidere = 5108;
export const wtw_soknader = 5109;
export const wtw_tilbud_og_annonser = 5110;
export const wtw_rekruttering_og_annonser = 5111;
export const wtw_kunder = 5112;
export const wtw_evaluering = 5113;
export const wtw_soknader_rekruttering = 5114;
export const wtw_evaluering_utfort_av_medarbeidere = 5115;
export const wtw_community_widget = 5116;
export const wtw_webtemp_roadmap = 5117;
export const wtw_garantilonnsoversikt = 5118;
export const wtw_nedtelling = 5119;

export const wtw_stolpe = 5200;
export const wtw_sektor_liggende = 5201;
export const wtw_sektor_3d = 5202;
export const wtw_liste = 5203;
export const wtw_liste_med_detaljer = 5204;
export const wtw_speedometer = 5205;
export const wtw_linjegraf = 5206;
export const wtw_trakt = 5207;

export const wtc_dashboard = 0;
export const wtc_search = -2;
export const wtc_utvalg = -3;
export const wtc_groups = -4;

export const wt_rettigheter = {};

export const typeRelatertNavn = {
  [wt_tilbud]: "tilbud",
  [wt_rekruttering]: "rekruttering",
  [wt_oppdrag]: "oppdrag",
  [wt_kunder]: "kunder",
  [wt_vikarer]: "vikarer",

  //[rettigheter]
  [121]: "Oppsett Konsern",
  [122]: "Oppsett Firma",
  [123]: "Oppsett Avdeling",
  [124]: "Maler Konsern",
  [125]: "Maler Firma",
  [126]: "Statistikk Konsern",
  [127]: "Statistikk Firma",
  [128]: "Statistikk Avdeling",
  [129]: "Faktura/Lønn - Konsern",
  [130]: "Faktura/Lønn - Firma",
  [131]: "Se alle saker i konsernet",
  [132]: "Se alle saker i firmaet",
  [134]: "Redigere alle saker i konsernet",
  [135]: "Redigere alle saker i firmaet",
  [137]: "Se dagboken for konsernet",
  [138]: "Se dagboken for firmaet",
  [140]: "Tildele kunder og vikarer systemrettigheter",
  [141]: "Registrere forhåndsdefinerte avdelings-søk",
  [142]: "Endre statuser",
  [143]: "Bytte konsulent",
  [144]: "Oppheve 'svartelistinger'",
  [145]: "Faktura/Lønn - Kreditere og eksportere",
  [146]: "Se personnummere uten faktura/lønn rettighet",
  [147]: "Redigere dashboardprofiler",

  //[periode]
  [150]: "Dag",
  [151]: "Uke",
  [152]: "Mnd",
  [153]: "Kvartal",
  [154]: "År",
  [155]: "Halvår",

  //[skattekortperiode]
  [160]: "1 uke",
  [161]: "2 uker",
  [162]: "1 måned",
  [163]: "4 dager",
  [164]: "3 dager",
  [165]: "2 dager",
  [166]: "1 dag",
  [167]: "Automatisk beregnet",

  //[regnskapsystem]
  [200]: "01.VISMA Business",
  [201]: "02.VISMA Global",
  [202]: "Ikke i bruk",
  [203]: "03.Rubicon",
  [205]: "04.MAMUT",
  [206]: "05.UNI",
  [207]: "06.Hogia",
  [208]: "07.DI Systemer AS",
  [209]: "08.Duett - ikke NLT",
  [210]: "09.Duett - for NLT",
  [211]: "10.ISS Norge",
  [212]: "11.ISS Sverige",
  [213]: "12.ISS Danmark",
  [214]: "13.XLedger",
  [215]: "14.VISMA Avendo",
  [216]: "05.UNI - Spesifiserte bilag",
  [217]: "15.Standard semikolonseparert",
  [218]: "16.XLedger AR10",
  [219]: "17.Tripletex",
  [220]: "18.Unit4 BusinessWorld",
  [221]: "19.24sevenoffice - GBAT10",

  //[enhet]
  [500]: "År",
  [501]: "Mnd",
  [502]: "Uke",
  [503]: "Dag",
  [504]: "Time",
  [505]: "Stk",

  //[fakturaoppfolging]
  [700]: "Ikke send epost fakturakopi til bestiller",
  [701]: "Fakturakontakt mottar originalfaktura",
  [702]: "Forskjellige kontakter på faktura",
  [703]: "Forskjellige referanser på faktura",
  [704]: "Kun en ordre pr faktura med timelisteperiodesplitt",
  [705]: "Ordrekontakt mottar faktura",
  [706]: "Ikke påminnelse på mail om timelister",
  [707]: "Forskjellige datterselskap på faktura",
  [708]: "Hold tilbake fakturaer",
  [709]: "Åpne for e-timelister",
  [710]: "Betalingssertifikat/tidsur",
  [711]: "Spesifiser timelister på fakturaene",
  [712]: "Vis kun totalsummen på fakturaene",
  [713]: "Kun en ordre pr faktura",
  [714]: "Kun en stillingskategori per faktura",
  [715]: "Ikke fakturagebyr",
  [717]: "Kun faktura på mail",
  [718]: "Konfidensiell - returner fakturaer",
  [719]: "Aktiver EHF-faktura",
  [720]: "Datterselskap mottar faktura",
  [721]: "Åpne for elektronisk import av timelister",
  [722]: "Fakturer på tvers av avdelinger",
  [723]: "Epostfaktura som vedlegg",
  [724]: "Bestiller må registreres med referansenummer",
  [725]: "Legg ved link til fakturadokument i EHF-faktura",
  [726]: "Vis lønn som fakturakommentar",
  [727]: "Kun en faktura pr epostfaktura",
  [728]: "Deaktiver EHF-faktura",
  [729]: "Akonto forskuddsbetaling",
  [730]: "Kunde dekker sykdomskostnader",
  [731]: "Kunde dekker høytids og helligdagskostnader",
  [732]: "Deaktiver bevegelig helligdagstillegg",
  [733]: "Kunde dekker permisjons og fraværskostnader",
  [734]: "Aktiver XML nedlasting av e-timelister",
  [735]: "Ekstern part garanterer utestående",
  [736]: "Forhåndsgodkjenning av timelister",
  [737]: "Skriftlige timelister pr prosjekt",
  [738]: "Automatisk behandling av godkjente timelister",

  //[styringskoder]
  [1205]: "aktiviteter/Klage",
  [1207]: "aktiviteter/Vikarhenvendelse",
  [1208]: "aktiviteter/Kundehenvendelse",
  [1209]: "aktiviteter/kundestatistikk",
  [1210]: "aktiviteter/vikarstatistikk",
  [1220]: "vikarstatus/Vis i hurtiglisten",
  [1221]: "vikarstatus/Headhuntet",
  [1222]: "vikarstatus/Sluttet",
  [1223]: "vikarstatus/Med i avansert søk",
  [1224]: "vikarstatus/Tildel vikarnummer",
  [1225]: "vikarstatus/Avslutt vikarnummer",
  [1226]: "vikarstatus/Svartelistet",
  [1227]: "vikarstatus/Sender faktura på timer",
  [1228]: "vikarstatus/Mottar fast lønn",
  [1229]: "vikarstatus/Automatisk vikarnummer",
  [1230]: "kundestatus/Med i avansert søk",
  [1231]: "kundestatus/Tildel kundenummer",
  [1232]: "kundestatus/Avslutt kundenummer",
  [1233]: "kundestatus/Finnes ikke lenger",
  [1234]: "kundestatus/Svartelistet",
  [1235]: "kundestatus/Vis i hurtiglisten",
  [1236]: "kundestatus/Fakturer morselskap",
  [1237]: "kundestatus/Registrer som leverandør",
  [1241]: "tilbudstatus/Ikke løst enda",
  [1242]: "tilbudstatus/Rekrutteringsfase over",
  [1243]: "tilbudstatus/Trukket",
  [1244]: "tilbudstatus/Tapt",
  [1245]: "tilbudstatus/Løst internt",
  [1246]: "tilbudstatus/Åpent",
  [1247]: "tilbudstatus/Ikke vis i statistikk",
  [1248]: "tilbudstatus/Nettregistrer->Ja",
  [1249]: "tilbudstatus/Nettregistrer->Nei",
  [1250]: "rekrutteringstatus/Ikke løst enda",
  [1251]: "rekrutteringstatus/Rekrutteringsfase over",
  [1252]: "rekrutteringstatus/Trukket",
  [1253]: "rekrutteringstatus/Tapt",
  [1254]: "rekrutteringstatus/Løst internt",
  [1255]: "rekrutteringstatus/Åpent",
  [1256]: "rekrutteringstatus/Evaluer",
  [1257]: "rekrutteringstatus/Ikke vis i statistikk",
  [1258]: "rekrutteringstatus/Nettregistrer->Ja",
  [1259]: "rekrutteringstatus/Nettregistrer->Nei",
  [1260]: "kandidatstatus/Til vurdering",
  [1261]: "kandidatstatus/Akseptert",
  [1262]: "kandidatstatus/Nettregistrert",
  [1263]: "kandidatstatus/Kandidat trukket",
  [1264]: "kandidatstatus/Ikke akseptert automail",
  [1266]: "gruppesvar/Ikke Vis i schedule",
  [1267]: "kandidatstatus/Kundeinnsyn",
  [1280]: "nettresyme/Ikke Vis i nettcv",
  [1281]: "nettresyme/Registrert via internett",
  [1282]: "vikarstatus/Kun aktuell i en rekrutteringssak",
  [1283]: "vikarstatus/Avslutt og skjul",
  [1284]: "kundestatus/Avslutt og skjul",
  [1285]: "kundestatus/Ønskes aktivert",
  [1286]: "vikarstatus/Ønskes aktivert",
  [1290]: "rapportering/Refusjonsberettiget",
  [1310]: "inntektsmerking/Vis i kunderegistreringsbilde",
  [1311]: "vikarstatus/Ikke overfør grunnlønn",
  [1312]: "vikarstatus/Ikke overfør lønnstakerinformasjon",
  [1317]: "systemhendelsekopier/Kopier mailoppsett fra master",
  [1318]: "systemhendelse/Deaktiver systemhendelse",
  [1319]: "systemhendelse/Ikke send automail",
  [1320]: "systemhendelse/Send automail umiddelbart",
  [1321]: "systemhendelse/Send automail etter 5min",
  [1322]: "systemhendelse/Send automail etter 30min",
  [1323]: "systemhendelse/Send automail etter 1time",
  [1324]: "systemhendelse/Send automail etter 1dag",
  [1325]: "systemhendelse/Send automail etter 3dager",
  [1326]: "systemhendelse/Send automail etter 7dager",
  [1327]: "systemhendelse/Send automail etter 14dager",
  [1328]: "systemhendelse/Automail med manuell bekreftelse",
  [1329]: "utvalgslister/Oppdrag",
  [1330]: "utvalgslister/Tilbud",
  [1331]: "utvalgslister/Rekruttering",
  [1332]: "utvalgslister/Timelister",
  [1333]: "utvalgslister/Epost ut",
  [1334]: "utvalgslister/Epost inn",
  [1335]: "utvalgslister/Telefonsamtale",
  [1336]: "utvalgslister/Systemhendelser",
  [1340]: "utvalgslister/Gruppe",
  [1341]: "utvalgslister/Filter",
  [1342]: "utvalgslister/Sortering",
  [1343]: "utvalgslister/Felt",
  [1344]: "utstyr/Felles ressurs alle kontor",
  [1345]: "aktiviteter/Utløs Systemhendelse dagbok",
  [1346]: "utstyr/Utløs Systemhendelse dagbok",
  [1350]: "kontaktfunksjoner/Bestiller",
  [1351]: "kontaktfunksjoner/Beslutningstaker",
  [1352]: "kontaktfunksjoner/Medarbeiders kontaktperson",
  [1353]: "vikarstatus/Aktivert via internett",
  [1354]: "WT classic/Skjul i Classic",
  [1360]: "sjekkliste/Medarbeider generelt",
  [1361]: "sjekkliste/Kunde generelt",
  [1362]: "sjekkliste/Sykdom",
  [1364]: "sjekkliste/Yrkesskade",
  [1366]: "sjekkliste/Oppdrag - medarbeider",
  [1367]: "sjekkliste/Oppdrag - kunde",
  [1368]: "utløpsdato/Krev utløpsdato",
  [1369]: "Ved avslutning av kandidat/Må sluttbehandles",
  [1370]: "Opprettet automatisk inngående partnerfaktura",
  [1371]: "vikarstatus/Tilgjengelig for JK partner",
  [1372]: "kundestatus/Tilgjengelig for JK partner",
  [1373]: "dokumentkategorier/Kunde",
  [1374]: "dokumentkategorier/Medarbeider",
  [1375]: "dokumentkategorier/Oppdrag",
  [1376]: "dokumentkategorier/Tilbud",
  [1377]: "dokumentkategorier/Rekruttering",
  [1378]: "dokumentkategorier/Timeliste og faktura",
  [1379]: "Kunnskap/Ikke obligatorisk på rekrutteringstidspunktet",
  [1380]: "utvalgslister/Kunder",
  [1381]: "utvalgslister/Vikarer",
  [1382]: "vikarstatus/Avslutt og slett informasjon",
  [1383]: "aktiviteter/Sykdom",
  [1384]: "aktiviteter/Permisjon",
  [1385]: "aktiviteter/Lovfestet permisjon",
  [1386]: "aktiviteter/Avtalt permisjon",
  [1387]: "evaluering",
  [1388]: "evaluering",

  //[avgiftskoder]
  [2100]: "01 Mvafritt utenfor avg.omr",
  [2101]: "02 Mvafritt innenfor avg.omr",
  [2102]: "03 Mvapliktig normal",
  [2103]: "04 Mvapliktig næringsmidler",
  [2104]: "05 Mvapliktig transport",
  [2105]: "00 Mvafritt ikke rapporteringspliktig",

  //[lonnsystem]
  [2201]: "System4 og Lønn5",
  [2202]: "Hogia Norsk",
  [2203]: "Hogia Svensk",
  [2206]: "VISMA lønn",
  [2207]: "UNI lønn",
  [2208]: "DI Systemer AS",
  [2209]: "Lønn5 for NLT",
  [2210]: "Personec LON02",
  [2211]: "ISS Danmark",
  [2212]: "Visma - tilpasset import",
  [2213]: "XLedger",
  [2214]: "Tripletex",
  [2215]: "SUNPRO",
  [2216]: "Webtemp innebygget",
  [2217]: "Standard semikolonseparert",
  [2218]: "Lønn5 V2",
  [2219]: "VISMA Lønn 2017",
  [2220]: "XLedger PM10",
  [2221]: "PAXml2",
  [2222]: "Multiløn MLE40LONA",
  [2223]: "Avendo lønn",
  [2224]: "Nettlønn",
  [2225]: "Xledger PR05 og HR09",

  //[janei]
  [3600]: "Ja",
  [3601]: "Nei",

  //[lonnsparametre]
  [4100]: "Skatt",
  [4101]: "Feriepenger",
  [4102]: "OTP",
  [4103]: "Arbeidsgiveravgift",
  [4104]: "Påleggstrekk",
  [4105]: "Arbeidsgiveravgift feriepenger",
  [4107]: "Utbetalt medarbeider",
  [4108]: "Overført skattetrekk",
  [4109]: "Totalt lønnslinjer",
  [4110]: "Utbetaling faktura",
  [4111]: "Inntektsopplysninger NAV",
  [4112]: "Utbetaling reskontro",
  [4113]: "Utbetaling avsetning",

  //[arbeidstidsordning]
  [4150]: "Arbeid offshore-33,6t",
  [4151]: "Døgnkontinuerlig skift og turnusarbeid-35,5t",
  [4152]: "Helkontinuerlig skiftarbeid og annnet 33,6t",
  [4153]: "Ikke skift",
  [4154]: "Skiftarbeid-36,5t",

  //[avlonningstype]
  [4200]: "Akkordlønn",
  [4201]: "Fastlønn",
  [4202]: "Honorar",
  [4203]: "Provisjonslønn-prosentlønn",
  [4204]: "Timelønn",
};

export const inferTypeRelatertfil = (hit, allowUnknown = true) => {
  if (hit.type_relatertfil) return hit.type_relatertfil;
  if (hit.typeRelatertfil) return hit.typeRelatertfil;
  if (hit.id_typer) return hit.id_typer;
  if (hit.trel) return hit.trel;
  if (hit.typeRelation) return hit.typeRelation;
  if (hit.typeRelated) return hit.typeRelated;

  if (!allowUnknown) {
    throw new Error("Kunne ikke avgjøre type_relatertfil");
  }
};

export const getIdRelatertfil = (
  row,
  type_relatertfil,
  allowUnknown = true
) => {
  let id_relatertfil = idRelatertfilOppslag(row, type_relatertfil);

  if (!id_relatertfil) {
    id_relatertfil =
      row.id_relatertfil ||
      row.idRelatertfil ||
      row.irel ||
      row.id_row ||
      row.id ||
      row.idRelation ||
      row.idRelated;
  }

  if (!id_relatertfil && !allowUnknown) {
    throw new Error("Kunne ikke avgjøre id_relatertfil");
  }

  return id_relatertfil;
};

export const inferIdRelatertfil = (row, allowUnknown = true) => {
  let type_relatertfil = inferTypeRelatertfil(row, allowUnknown);
  let id_relatertfil = idRelatertfilOppslag(row, type_relatertfil);

  if (!id_relatertfil) {
    id_relatertfil =
      row.id_relatertfil ||
      row.idRelatertfil ||
      row.irel ||
      row.id_row ||
      row.id ||
      row.idRelation ||
      row.idRelated;
  }

  if (!id_relatertfil && !allowUnknown) {
    throw new Error("Kunne ikke avgjøre id_relatertfil");
  }

  return id_relatertfil;
};

// ---------------------------------------------------------------------
// OPPDATER ALLE FUNKSJONER UNDER FOR Å LEGGE NYE TYPER TIL KONTEKSTMENY
// ---------------------------------------------------------------------

export const getActionType = (type_relatertfil) => {
  if (type_relatertfil === wt_avtaler) return wt_avtaler;

  if (type_relatertfil === wt_vikarer) return wt_vikarer;
  if (type_relatertfil === wt_firmavikarer) return wt_vikarer;

  if (type_relatertfil === wt_kunder) return wt_kunder;
  if (type_relatertfil === wt_firmakunder) return wt_kunder;

  if (type_relatertfil === wt_kontakter) return wt_kontakter;
  if (type_relatertfil === wt_firmakontakter) return wt_kontakter;

  if (type_relatertfil === wt_tilbud) return wt_tilbud;

  if (type_relatertfil === wt_oppdrag) return wt_oppdrag;

  if (type_relatertfil === wt_faktura) return wt_faktura;

  if (type_relatertfil === wt_rekruttering) return wt_rekruttering;

  if (type_relatertfil === wt_dokumenter) return wt_dokumenter;

  if (type_relatertfil === wt_dagbok) return wt_dagbok;

  if (type_relatertfil === wt_systemhendelser) return wt_systemhendelser;

  if (type_relatertfil === wt_kandidater) return wt_kandidater;
  if (type_relatertfil === wt_rekrutteringskandidat)
    return wt_rekrutteringskandidat;

  if (type_relatertfil === wt_timelister) return wt_timelister;

  if (type_relatertfil === wt_emailbeskjeder) return wt_emailbeskjeder;

  if (type_relatertfil === wt_vikarerpresentert) return wt_vikarerpresentert;

  if (type_relatertfil === wt_tekst) return wt_tekst;

  if (type_relatertfil === wt_dtekst) return wt_dtekst;

  if (type_relatertfil === wt_arkivimport) return wt_arkivimport;

  if (type_relatertfil === wt_arkivimport_item) return wt_arkivimport_item;

  if (type_relatertfil === wt_rssartikkel) return wt_rssartikkel;

  if (type_relatertfil === wt_nyhetsartikkel) return wt_nyhetsartikkel;

  if (type_relatertfil === wt_changelogartikkel) return wt_changelogartikkel;

  if (type_relatertfil === wt_praksis) return wt_praksis;
  if (type_relatertfil === wt_skoler) return wt_skoler;
  if (type_relatertfil === wt_kurs) return wt_kurs;
  if (type_relatertfil === wt_kunnskap) return wt_kunnskap;
  if (type_relatertfil === wt_produkter) return wt_produkter;
  if (type_relatertfil === wt_produktpris) return wt_produktpris;
  if (type_relatertfil === wt_passord) return wt_passord;
  if (type_relatertfil === wt_vikarpriser) return wt_vikarpriser;

  return wt_ukjent;
};

export const GetSolidIcon = (wt_type) => {
  wt_type = Number(wt_type);

  if (wt_type === wt_kunder) return "fas-address-card";
  if (wt_type === wt_kontakter) return "fas-user-tie";
  if (wt_type === wt_vikarer) return "fas-users";
  if (wt_type === wt_tilbud) return "fas-briefcase";
  if (wt_type === wt_oppdrag) return "fas-handshake";
  if (wt_type === wt_faktura) return "fas-money-check";
  if (wt_type === wt_rekruttering) return "fas-registered";
  if (wt_type === wt_timelister) return "TimeSheet";
  if (wt_type === wt_dokumenter) return "Document";
  if (wt_type === wt_dagbok) return "fas-calendar-alt";
  //if (wt_type === wt_vikarerpresentert) return "fas-presentation";
  if (wt_type === wt_systemhendelser) return "fas-info-circle";
  if (wt_type === wt_kandidater) return "fas-user";
  if (wt_type === wt_rekrutteringskandidat) return "fas-user";
  if (wt_type === wtc_dashboard) return "fas-home";
  if (wt_type === wtc_utvalg) return "fas-sitemap";
  if (wt_type === wtc_groups) return "fas-users";
  if (wt_type === wt_tekst) return "Comment";
  if (wt_type === wt_dtekst) return "Comment";

  if (wt_type === wt_rssartikkel) return "Articles";
  if (wt_type === wt_nyhetsartikkel) return "Articles";
  if (wt_type === wt_changelogartikkel) return "Articles";

  if (wt_type === wt_avtaler) return "fas-money-check";

  if (wt_type === wt_praksis) return undefined;
  if (wt_type === wt_skoler) return undefined;
  if (wt_type === wt_kurs) return undefined;
  if (wt_type === wt_kunnskap) return undefined;
  if (wt_type === wt_produkter) return undefined;
  if (wt_type === wt_produktpris) return undefined;
  if (wt_type === wt_passord) return undefined;
  if (wt_type === wt_vikarpriser) return undefined;

  if (wt_type === wt_emailbeskjeder) return "fas-envelope";

  return undefined;
};

export const GetIcon = (wt_type) => {
  wt_type = Number(wt_type);

  if (wt_type === wt_kunder) return "fal-address-card";
  if (wt_type === wt_kontakter) return "fal-user-tie";
  if (wt_type === wt_vikarer) return "fal-users";
  if (wt_type === wt_tilbud) return "fal-briefcase";
  if (wt_type === wt_oppdrag) return "fal-handshake";
  if (wt_type === wt_faktura) return "fal-money-check";
  if (wt_type === wt_rekruttering) return "fal-registered";
  if (wt_type === wt_timelister) return "TimeSheet";
  if (wt_type === wt_dokumenter) return "Document";
  if (wt_type === wt_dagbok) return "fal-calendar-alt";
  //if (wt_type === wt_vikarerpresentert) return "fal-presentation";
  if (wt_type === wt_systemhendelser) return "fal-info-circle";
  if (wt_type === wt_kandidater) return "fal-user";
  if (wt_type === wt_rekrutteringskandidat) return "fal-user";
  if (wt_type === wtc_dashboard) return "fal-home";
  if (wt_type === wtc_utvalg) return "fal-sitemap";
  if (wt_type === wtc_groups) return "fal-users";
  if (wt_type === wt_tekst) return "Comment";
  if (wt_type === wt_dtekst) return "Comment";

  if (wt_type === wt_rssartikkel) return "Articles";
  if (wt_type === wt_nyhetsartikkel) return "Articles";
  if (wt_type === wt_changelogartikkel) return "Articles";

  if (wt_type === wt_avtaler) return "fal-money-check";

  if (wt_type === wt_praksis) return undefined;
  if (wt_type === wt_skoler) return undefined;
  if (wt_type === wt_kurs) return undefined;
  if (wt_type === wt_kunnskap) return undefined;
  if (wt_type === wt_produkter) return undefined;
  if (wt_type === wt_produktpris) return undefined;
  if (wt_type === wt_passord) return undefined;
  if (wt_type === wt_vikarpriser) return undefined;

  if (wt_type === wt_emailbeskjeder) return "fal-envelope";

  return undefined;
};

export const GetSingularText = (wt_type) => {
  wt_type = Number(wt_type);

  if (wt_type === wt_kunder) return "Kunde";
  if (wt_type === wt_firmakunder) return "Kunde";
  if (wt_type === wt_kontakter) return "Kontakt";
  if (wt_type === wt_vikarer) return "Medarbeider";
  if (wt_type === wt_firmavikarer) return "Medarbeider";

  if (wt_type === wt_avtaler) return "Avtale";

  if (wt_type === wt_tilbud) return "Ledig stilling";
  if (wt_type === wt_oppdrag) return "Oppdrag";
  if (wt_type === wt_faktura) return "Faktura";
  if (wt_type === wt_rekruttering) return "Rekruttering";
  if (wt_type === wt_dokumenter) return "Dokument";
  if (wt_type === wt_dagbok) return "Dagbokoppføring";
  if (wt_type === wt_systemhendelser) return "Systemhendelse";
  if (wt_type === wt_timelister) return "Timeliste";
  if (wt_type === wt_kandidater) return "Stillingskandidat";
  if (wt_type === wt_rekrutteringskandidat) return "Rekrutteringskandidat";
  if (wt_type === wt_emailbeskjeder) return "Melding";
  if (wt_type === wt_vikarerpresentert) return "Kandidatpresentasjon";
  if (wt_type === wt_tekst) return "Tekst";
  if (wt_type === wt_dtekst) return "Datert tekst";
  if (wt_type === wt_arkivimport) return "Arkivimport";
  if (wt_type === wt_arkivimport_item) return "Arkivimportrad";

  if (wt_type === wt_rssartikkel) return "Rss-artikkel";
  if (wt_type === wt_nyhetsartikkel) return "Nyhetsartikkel";
  if (wt_type === wt_changelogartikkel) return "Endringsartikkel";

  if (wt_type === wt_praksis) return "Praksis";
  if (wt_type === wt_skoler) return "Skoler";
  if (wt_type === wt_kurs) return "Kurs";
  if (wt_type === wt_kunnskap) return "Kunnskap";

  if (wt_type === wt_produkter) return "Produkt";
  if (wt_type === wt_produktpris) return "Produkt/Tillegg";

  if (wt_type === wt_passord) return "Passord";
  if (wt_type === wt_vikarpriser) return "Medarbeiderpris";

  if (wt_type === wt_ukjent) return "Ukjent";

  return "Ukjent";
};

export const GetPluralText = (wt_type) => {
  wt_type = Number(wt_type);

  if (wt_type === wt_kunder) return "Kunder";
  if (wt_type === wt_firmakunder) return "Kunder";
  if (wt_type === wt_kontakter) return "Kontakter";
  if (wt_type === wt_vikarer) return "Medarbeidere";
  if (wt_type === wt_avtaler) return "Avtaler";
  if (wt_type === wt_tilbud) return "Ledige stillinger";
  if (wt_type === wt_oppdrag) return "Oppdrag";
  if (wt_type === wt_faktura) return "Fakturaer";
  if (wt_type === wt_rekruttering) return "Rekrutteringer";
  if (wt_type === wt_dokumenter) return "Dokumenter";
  if (wt_type === wt_dagbok) return "Dagboksoppføringer";
  if (wt_type === wt_timelister) return "Timelister";
  if (wt_type === wt_systemhendelser) return "Systemhendelser";
  if (wt_type === wt_kandidater) return "Stillingskandidater";
  if (wt_type === wt_rekrutteringskandidat) return "Rekrutteringskandidater";
  if (wt_type === wt_emailbeskjeder) return "Meldinger";
  if (wt_type === wt_vikarerpresentert) return "Kandidatpresentasjoner";
  if (wt_type === wt_tekst) return "Tekster";
  if (wt_type === wt_arkivimport) return "Arkivimporter";
  if (wt_type === wt_arkivimport_item) return "Arkivimportrader";

  if (wt_type === wt_rssartikkel) return "Rss-artikler";
  if (wt_type === wt_nyhetsartikkel) return "Nyhetsartikler";
  if (wt_type === wt_changelogartikkel) return "Endringsartikler";

  if (wt_type === wt_dtekst) return "Daterte tekster";

  if (wt_type === wt_praksis) return "Praksiser";
  if (wt_type === wt_skoler) return "Skoler";
  if (wt_type === wt_kurs) return "Kurs";
  if (wt_type === wt_kunnskap) return "Kunnskaper";

  if (wt_type === wt_produkter) return "Produkter";
  if (wt_type === wt_produktpris) return "Produkt/Tillegg";

  if (wt_type === wt_passord) return "Passord";
  if (wt_type === wt_vikarpriser) return "Medarbeiderpriser";

  if (wt_type === wt_ukjent) return "Ukjente";

  return "UDEFINERTE";
};

export const idRelatertfilOppslag = (row, type_relatertfil) => {
  type_relatertfil = Number(type_relatertfil);
  let id_relatertfil;

  if (type_relatertfil === wt_vikarer) {
    id_relatertfil = row.id_vikarer || row.id_vikar || row.idCandidate;
  } else if (type_relatertfil === wt_kunder) {
    id_relatertfil = row.id_kunder || row.id_kunde || row.idCustomer;
  } else if (type_relatertfil === wt_kontakter) {
    id_relatertfil =
      row.id_kontakter || row.id_kontakt || row.idPersonalConsultant;
  } else if (type_relatertfil === wt_tilbud) {
    id_relatertfil = row.id_tilbud;
  } else if (type_relatertfil === wt_oppdrag) {
    id_relatertfil = row.id_oppdrag;
  } else if (type_relatertfil === wt_faktura) {
    id_relatertfil = row.id_faktura || row.id_fakturaer;
  } else if (type_relatertfil === wt_rekruttering) {
    id_relatertfil = row.id_rekruttering;
  } else if (type_relatertfil === wt_timelister) {
    id_relatertfil = row.id_timelister || row.id_timeliste;
  } else if (type_relatertfil === wt_dokumenter) {
    id_relatertfil = row.id_dokumenter || row.id_dokument;
  } else if (type_relatertfil === wt_dagbok) {
    id_relatertfil = row.id_dagbok || row.idDiary;
  } else if (type_relatertfil === wt_systemhendelser) {
    id_relatertfil = row.id_systemhendelser || row.id_systemhendelse;
  } else if (type_relatertfil === wt_kandidater) {
    id_relatertfil = row.id_kandidat || row.id_kandidater;
  } else if (type_relatertfil === wt_rekrutteringskandidat) {
    id_relatertfil =
      row.id_rekrutteringskandidat || row.id_rekrutteringskandidater;
  } else if (type_relatertfil === wt_emailbeskjeder) {
    id_relatertfil = row.id_emailbeskjed || row.id_emailbeskjeder;
  } else if (type_relatertfil === wt_vikarerpresentert) {
    id_relatertfil = row.id_vikarerpresentert;
  } else if (type_relatertfil === wt_tekst) {
    id_relatertfil = row.id_tekst || row.id_tekster;
  } else if (type_relatertfil === wt_dtekst) {
    id_relatertfil = row.id_dtekst || row.id_dtekster;
  } else if (type_relatertfil === wt_arkivimport) {
    id_relatertfil = row.id_arkivimport || row.id_arkivimporter;
  } else if (type_relatertfil === wt_arkivimport_item) {
    id_relatertfil = row.id_arkivimport_item;
  } else if (type_relatertfil === wt_rssartikkel) {
    id_relatertfil = row.id_rssartikkel;
  } else if (type_relatertfil === wt_changelogartikkel) {
    id_relatertfil = row.id_changelogartikkel;
  } else if (type_relatertfil === wt_nyhetsartikkel) {
    id_relatertfil = row.id_nyhetsartikkel;
  } else if (type_relatertfil === wt_praksis) {
    id_relatertfil = row.id_praksis || row.idPractices;
  } else if (type_relatertfil === wt_skoler) {
    id_relatertfil = row.id_skoler || row.idSchools;
  } else if (type_relatertfil === wt_kurs) {
    id_relatertfil = row.id_kurs || row.idCourses;
  } else if (type_relatertfil === wt_kunnskap) {
    id_relatertfil = row.id_kunnskap || row.idKnowledge;
  } else if (type_relatertfil === wt_avtaler) {
    id_relatertfil = row.id_avtaler || row.idDeal;
  } else if (type_relatertfil === wt_produkter) {
    id_relatertfil = row.id_produkter || row.idProduct || row.idProducts;
  } else if (type_relatertfil === wt_produktpris) {
    id_relatertfil = row.id_produktpris || row.idProductPrice;
  } else if (type_relatertfil === wt_passord) {
    id_relatertfil = row.id_passord || row.idPassword;
  } else if (type_relatertfil === wt_vikarpriser) {
    id_relatertfil = row.id_vikarpris || row.id_vikarpriser;
  }

  return id_relatertfil;
};
